import React from 'react';
import { useSelector } from 'react-redux';

import { Box, Divider, Paper, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

import { OrderDeliveryService } from 'common/types';
import { getPricingString } from 'common/utils/common';
import { useTranslation } from 'services/localization/useTranslation';

import * as ShopSelectors from 'selectors/ShopSelectors';

interface Props {
	orderDelivery: OrderDeliveryService;
}

const DeliveryPayment = (props: Props) => {
	const { orderDelivery } = props;
	const classes = useStyles(props);
	const { t, getTranslation } = useTranslation();

	const currency = useSelector(ShopSelectors.getShopCurrency);

	const renderDeliveryPaymentRow = (name: string, price: number) => (
		<Box className={classes.wrapper} mt={1}>
			<Box className={classes.productName}>
				<Typography variant="body2" display="inline">
					{name}
				</Typography>
			</Box>
			<Box>
				<Typography variant="body2" className={classes.subtotal}>
					{getPricingString(price, currency)}
				</Typography>
			</Box>
		</Box>
	);

	return (
		<Paper elevation={1} className={classes.container}>
			<Box display="flex" alignItems="center" mb={1}>
				<Typography variant="h6">{t('delivery.delivery', 'Delivery')}</Typography>
			</Box>
			{orderDelivery.to?.pricing?.listPrice !== undefined &&
				renderDeliveryPaymentRow(
					getTranslation(orderDelivery.name),
					orderDelivery.to.pricing?.listPrice,
				)}
			{!!orderDelivery.from?.pricing?.listPrice &&
				renderDeliveryPaymentRow(t('delivery.pickup'), orderDelivery.from.pricing?.listPrice)}
			<Divider className={classes.divider} />
			<Box className={classes.wrapper} mt={1}>
				<Box className={classes.productName}>
					<Typography variant="body2">{t('shoppingCart.total')}</Typography>
				</Box>
				<Box>
					<Typography variant="body2">
						<b>{getPricingString(orderDelivery.pricing.listPrice, currency)}</b>
					</Typography>
				</Box>
			</Box>
		</Paper>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		container: {
			padding: theme.spacing(4),
			margin: theme.spacing(2, 0),
		},
		wrapper: {
			display: 'flex',
			alignItems: 'flex-end',
			flexDirection: 'row',
		},
		productName: {
			flex: 1,
			display: 'flex',
		},
		subtotal: {
			fontWeight: 500,
		},
		divider: {
			margin: theme.spacing(0.5, 0),
		},
		icon: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			marginRight: theme.spacing(1.5),
		},
	}),
);

export default DeliveryPayment;
